<template>
    <div class="group-QR">
      <div class="group-QR-item" @click="openDialog(1)">
        <div class="title">账号买卖群<span v-if="showIndex===1">-</span><span v-else>+</span></div>
        <div v-if="showIndex===1"><img :src="moyus" style="width: 240px;height: 350px;"></div>
      </div>
      <div class="group-QR-item" @click="openDialog(2)">
        <div class="title">英雄联盟群<span v-if="showIndex===2">-</span><span v-else>+</span></div>
        <div v-if="showIndex===2"><img :src="legends" style="width: 240px;height: 350px;"></div>
      </div>
      <div class="group-QR-item" @click="openDialog(3)">
        <div class="title">王者荣耀群<span v-if="showIndex===3">-</span><span v-else>+</span></div>
        <div v-if="showIndex===3"><img :src="kings" style="width: 240px;height: 350px;"></div>
      </div>
      <div class="group-QR-item" @click="openDialog(4)">
        <div class="title" style="border-bottom: none;">dota群<span v-if="showIndex===4">-</span><span v-else>+</span></div>
        <div v-if="showIndex===4"><img :src="dotas" style="width: 240px;height: 350px;"></div>
      </div>
    </div>
  </template>

<script>
import moyus from '@/assets/groupQR/4.png'
import dotas from '@/assets/groupQR/2.png'
import kings from '@/assets/groupQR/3.png'
import legends from '@/assets/groupQR/1.png'
export default {
  name: 'GroupQR',
  data () {
    return {
      moyus,
      dotas,
      kings,
      legends,
      showIndex: 0
    }
  },
  methods: {
    openDialog (index) {
      if (this.showIndex === index) {
        this.showIndex = 0
      } else {
        this.showIndex = index
      }
    }
  }
}
</script>

  <style scoped lang="less">
.group-QR{
    position: absolute;
    right: 30px;
    top: 200px;
    z-index: 9999;
    .title{
        font-size: 18px;
        color: #0e5da1;
        font-weight: bolder;
        cursor: pointer;
        border-bottom: 1px solid #497aba;
        padding-top: 5px;
        padding-bottom: 5px;
        span{
            transform: scale(1.3);
        }
    }
}
  </style>
